<template>
  <div>
    <div
      v-if="companies.length"
      class="d-flex flex-row flex-nowrap align-items-center justify-content-left"
    >
      <div
        v-for="company in companies"
        :key="company.id"
        class="ml-1"
      >
        <company-thumb
          :logo="company.logo"
          :name="company.name"
          :removable="true"
          @select="handleSelectCompany(company.id)"
          @remove="handleRemoveCompany(company.id)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { avatarText } from '@core/utils/filter'
import CompanyThumb from '@/views/components/CompanyThumb.vue'
import { EventBus } from '@core/utils/utils'

export default {
  components: {
    CompanyThumb,
  },
  setup() {
    return {
      avatarText,
    }
  },
  props: {
    companies: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleSelectCompany(id) {
      EventBus.$emit('selectCompany', id)
    },
    handleRemoveCompany(id) {
      EventBus.$emit('removeCompany', id)
    },
  },
}
</script>
<style lang="scss">

</style>
